import { service } from '../axios';
export function getLearnStudy(params) {
    return service({
        url: '/learn/study',
        method: 'get',
        params
    });
}
export function getLearnHome() {
    return service({
        url: '/learn/home',
        method: 'get'
    });
}
export function getUserLearnReport() {
    return service({
        url: '/learn/getUserLearnReport',
        method: 'get'
    });
}
export function getLearnCategoryList(params) {
    return service({
        url: '/learn/category',
        method: 'get',
        params
    });
}
export function searchLearnContent(params) {
    return service({
        url: '/learn/content/search',
        method: 'get',
        params
    });
}
export function getLearnContentDetail(id) {
    return service({
        url: '/learn/content/detail',
        method: 'get',
        params: { id }
    });
}
export function getAllLearnVideos() {
    return service({
        url: '/learn/category/getAllLearnVideos',
        method: 'get'
    });
}
export function getLearnCategoryMenu() {
    return service({
        url: '/learn/category/menu',
        method: 'get'
    });
}
/* 查询待学习内容 */
export function getPendingLearning() {
    return service({
        url: '/learn/user/pending-learning',
        method: 'get'
    });
}
/* 查询待考试课程 */
export function getPendingExams() {
    return service({
        url: '/learn/user/pending-exams',
        method: 'get'
    });
}
/* 查询考试证书 */
export function getCertificates() {
    return service({
        url: '/learn/user/getCertificates',
        method: 'get'
    });
}
/** 标记文章学完 */
export function markLearnFinished(contentId) {
    return service({
        url: '/learn/user/finished',
        method: 'post',
        params: { contentId }
    });
}
/** 查询学习状态 */
export function getLearnStatus(contentId) {
    return service({
        url: '/learn/user/status',
        method: 'get',
        params: { contentId }
    });
}
/** 标记章节学完（新接口，前端调用） */
export function markLearnChapterFinished(contentId, chapterId) {
    return service({
        url: '/learn/user/chapterFinished',
        method: 'post',
        params: { contentId, chapterId }
    });
}
export function getExamRecordPage(params) {
    return service({
        url: '/learn/user/exam-record/page',
        method: 'get',
        params
    });
}
export function getExperimentCourses(params) {
    return service({
        url: '/learn/category',
        method: 'get',
        params
    });
}
export function getLabReservations(params) {
    return service({
        url: '/learn/category',
        method: 'get',
        params
    });
}
